/* global */

if (!customElements.get('cart-accordions')) {
  class CartAccordions extends HTMLElement {
    constructor() {
      super();
      this.accordionItems = this.querySelectorAll('.cart-accordion-item');
      this.init();
    }

    init() {
      this.accordionItems.forEach((item) => {
        const summary = item.querySelector('summary');
        const panel = item.querySelector('.cart-accordions_panel__QytDw');
        
        if (!panel || !summary) return;

        // Check if the panel has a CSS transition
        if (window.getComputedStyle(panel).transitionDuration !== '0s') {
          summary.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.handleToggle(item, panel);
          });
          
          panel.addEventListener('transitionend', () => {
            this.handleTransitionEnd(item, panel);
          });
        }
      });
    }

    handleToggle(item, panel) {
      if (!item.open) {
        this.open(item, panel);
      } else {
        this.close(item, panel);
      }
    }

    open(item, panel) {
      // Set height to 0 before opening
      panel.style.height = '0';
      
      // Open the details element
      item.open = true;
      
      // Set height to scroll height to enable transition
      requestAnimationFrame(() => {
        panel.style.height = `${panel.scrollHeight}px`;
      });
    }

    close(item, panel) {
      // Set height to scroll height first
      panel.style.height = `${panel.scrollHeight}px`;
      
      // Add closing class
      item.classList.add('is-closing');
      
      // Set height to 0 to trigger transition
      requestAnimationFrame(() => {
        panel.style.height = '0';
      });
    }

    handleTransitionEnd(item, panel) {
      if (item.classList.contains('is-closing')) {
        item.classList.remove('is-closing');
        item.open = false;
      }
      
      // Remove inline style after transition
      if (!item.open) {
        panel.removeAttribute('style');
      }
    }
  }

  customElements.define('cart-accordions', CartAccordions);
}
